import { createContext, useContext } from 'react';

/**
 * Provides the current supplement's write permission to deeply-nested cards
 * (room breakdown → room card → category → line item card → justification footer)
 * without prop-drilling. Defaults to read-only (false) so unknown/loading state
 * never exposes edit affordances.
 */
const SupplementAccessContext = createContext<boolean>(false);

export const SupplementAccessProvider = SupplementAccessContext.Provider;

export function useSupplementCanWrite(): boolean {
  return useContext(SupplementAccessContext);
}
